import { dataChevronRight } from 'dls-icons-data'
import { createIcon } from '../common'

const IconChevronRight = /*#__PURE__*/createIcon(dataChevronRight)
export default IconChevronRight
